import { stringToDocumentFragment } from "@gr-exports/async/dom";
import { o_util } from "@gr-common/async/namespaces";
import type { NexusHandler } from "../../nexus/function/function.types";
import type { DomRaw } from "../index.js";

export interface HardcoreLegacy {
  activateInlineScripts: typeof o_util.hardcore.executeInlineScripts;
}

export const hardcoreLegacy = o_util.hardcore as unknown as HardcoreLegacy;

export interface InsertHtmlFragmentOptions {
  /**
 *
 *
 *
 *
 */
  activateInlineScripts?: boolean;
}

export const insertHtmlFragment = ((htmlString, parent = document.body, options = {}): Node[] => {
  const { activateInlineScripts: runInlineScripts = true } = options;
  const fragment = stringToDocumentFragment(htmlString);
  const result = [...fragment.childNodes];
  parent.appendChild(fragment);

  if (runInlineScripts) hardcoreLegacy.activateInlineScripts(parent);

  return result;
}) satisfies NexusHandler<DomRaw["insertHtmlFragment"]>;
